module.exports = __webpack_public_path__ + "static/tactics_collection_pozemni_hokej-a0d7702197c09e5ea6d3ead3107f7244.mp4";